import { FilterHorizontalIc } from '@dsch/dd-icons';

import { QuickFilter } from '../../../../components/SearchPage/features/QuickFilters/components/QuickFilter/QuickFilter';
import { FilterDisplay } from '../../../../components/SearchPage/features/QuickFilters/components/FilterBottomSheet/FilterBottomSheet';

import { useQuickFilters } from '../../../../components/SearchPage/features/QuickFilters/QuickFilters.hook';

import * as Styled from '../../../../components/SearchPage/features/QuickFilters/QuickFilters.styled';

import type { QuickFiltersProps } from '../../../../components/SearchPage/features/QuickFilters/QuickFilters.typed';

import { theme } from '../../../../helpers/Theme';
import {
  LocationProvider,
  useLocationContext,
} from '../../../../features/location/Location.context';

import { MakeModelProvider } from '../../../../components/SearchPage/features/makeModel/MakeModelContext';
import { PAGE } from '../../../../helpers/pages';
import { shouldShowTrims } from '../makeModel/MakeModel.constants';

const QuickFilters = (props: QuickFiltersProps) => {
  const { className, sectionName, subsectionName } = props;

  const showTrims = shouldShowTrims(sectionName);

  const { openFilterModal, quickFiltersData, countDisplay, displayText } =
    useQuickFilters();

  const {
    countyList,
    coordinates: initialCoordinates,
    radiusList,
    locationDisplay,
    selectedCounty,
    radius,
    countyTown,
  } = useLocationContext();

  return (
    <MakeModelProvider>
      <LocationProvider
        initialSelectedCounty={selectedCounty}
        initialRadius={radius}
        initialLocationDisplay={locationDisplay}
        initialCoordinates={initialCoordinates}
        initialCountyTown={countyTown}
        countyList={countyList}
        radiusList={radiusList}
        page={PAGE.SEARCH}
      >
        <Styled.OuterContainer className={className}>
          <Styled.InnerContainer>
            <Styled.FilterModalButton inline onClick={openFilterModal}>
              <FilterHorizontalIc
                color={theme.colors.WHITE}
                height={20}
                width={20}
                data-testid="filter-button"
              />
              &nbsp;Filters{countDisplay}
            </Styled.FilterModalButton>
            {quickFiltersData.map((filter) => {
              // TODO:This isn't ideal, Make this backend driven.
              // If the API is updated now, the title will be incorrect on production.
              // We should merge this before after go live and come back and tidy up.
              // https://github.com/distilledmedia/dsch-dd-filters/pull/451/files

              const fallbackDisplayText =
                filter.name === 'makeModel'
                  ? showTrims
                    ? 'Make, Model & Trim'
                    : 'Make / Model'
                  : filter.displayName;

              return (
                <QuickFilter
                  filter={filter}
                  key={`quick-filter-${filter.name}`}
                  displayText={displayText(filter) ?? fallbackDisplayText}
                  sectionName={sectionName}
                />
              );
            })}
            <Styled.FilterModalLink
              ofType="SECONDARY"
              onClick={openFilterModal}
            >
              All Filters
            </Styled.FilterModalLink>
          </Styled.InnerContainer>
        </Styled.OuterContainer>
        <FilterDisplay
          sectionName={sectionName}
          subsectionName={subsectionName}
        />
      </LocationProvider>
    </MakeModelProvider>
  );
};

export { QuickFilters };
